/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react'

import { Loader } from 'components'

export interface Props {
  isLoading: boolean
}

export const LoaderCover: React.FC<Props> = (props: Props) => {
  const { isLoading } = props

  if (!isLoading) {
    return null
  }

  return (
    <div className='loader-cover-con' data-testid='loader-cover'>
      <Loader size='lg' />
    </div>
  )
}

export default LoaderCover
